import { render, staticRenderFns } from "./camera.vue?vue&type=template&id=5329a05c"
import script from "./camera.ts?vue&type=script&lang=js&external"
export * from "./camera.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports